import {
  fetchEventSource
} from "@microsoft/fetch-event-source";
const token = process.env.VUE_APP_DIFY_TOKEN;
// const controller = new AbortController(); // 用于取消请求
// const baseURL = process.env.VUE_APP_API_BASE_URL;
const baseURL = '/api/sse';
const service = ({
  url,
  method = "GET",
  data,
  headers = {},
  signal,
  onmessage = () => null,
  onerror = () => null
}) => {
  const request_data = {};
  headers = Object.assign({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    headers
  );
  if (method.toLocaleLowerCase() === "get") {
    Object.assign(request_data, {
      data
    });
  } else {
    Object.assign(request_data, {
      body: JSON.stringify(data)
    });
  }
  return fetchEventSource(baseURL + url, {
    method,
    signal: signal,
    // 如果是POST请求，可以添加headers和body
    headers,
    ...request_data,
    openWhenHidden: true, // 如果需要在页面隐藏时也接收消息
    onmessage: (e) => {
      if (typeof e.data === 'string') {
        try {
          onmessage(JSON.parse(e.data));
        } catch (error) {
          console.error('Received message is not a valid JSON', error);
        }
      }
    },
    onerror: () => {
      if (signal && signal.aborted) {
        console.log("Request manually aborted");
        return; // 停止重试
      }
      onerror('未知错误, 正在重新加载...')
      sessionStorage.removeItem(`${process.env.VUE_APP_NAME}:conversation_id`)
      location.reload()
    },
  });
};

export default service;
